import { SR_API_ACTION_SET_EXPERIMENT_ACTIVE_VARIANTS } from 'api/actionTypes';

export default async function setExperimentVariant({ state, apiClient }, payload) {
  await apiClient.postWithState({
    action: SR_API_ACTION_SET_EXPERIMENT_ACTIVE_VARIANTS,
    state: state,
    payload: {
      experimentActiveVariants: payload.experimentActiveVariants,
    },
    onSuccess({ experimentActiveVariants }) {
      state.set(['analytics', 'experiments', 'activeVariants'], experimentActiveVariants);
    },
  });
}
